export default "__VITE_ASSET__BSsHstSD__"